import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import DIcon from '../DIcon';
export default function PasswordCheckItem({ password, regex, text, }) {
    const isValid = regex.test(password);
    return (_jsxs("li", { className: "d-flex gap-2 align-items-start small text-gray-600", children: [_jsx(DIcon, { className: classNames('flex-shrink-0', isValid ? 'text-success' : 'text-gray-300'), icon: isValid ? 'CircleCheck' : 'Circle', size: "16px" }), _jsx("span", { className: classNames({ 'text-success': isValid }), children: text })] }));
}
//# sourceMappingURL=PasswordCheckItem.js.map